import { social } from "@/content/siteContent";

const icons = {
  facebook: (
    <path d="M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.69 4.53-4.69 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.96.93-1.96 1.89v2.26h3.33l-.53 3.49h-2.8V24C19.61 23.1 24 18.1 24 12.07z" />
  ),
  tiktok: (
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64c.3 0 .58.04.86.12V9.4a6.34 6.34 0 0 0-1-.08A6.34 6.34 0 0 0 3 15.66 6.34 6.34 0 0 0 9.34 22a6.34 6.34 0 0 0 6.34-6.34V8.69a8.2 8.2 0 0 0 4.76 1.52V6.76a4.85 4.85 0 0 1-.85-.07z" />
  ),
};

export const SocialLinks = ({ place }) => (
  <div className="social-links" data-testid={`${place}-social-links`}>
    {social.map((s) => {
      const icon = (
        <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">{icons[s.id]}</svg>
      );
      return s.url ? (
        <a key={s.id} href={s.url} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label={s.label} data-testid={`${place}-${s.id}-link`}>{icon}</a>
      ) : (
        <span key={s.id} className="social-icon" aria-label={s.label} title={s.label} data-testid={`${place}-${s.id}-link`}>{icon}</span>
      );
    })}
  </div>
);
